// src/components/Settings/TaxSettings.jsx
import React, { useState } from 'react';

export default function TaxSettings({ settings, onUpdate, loading }) {
  const [taxRate, setTaxRate] = useState(settings?.tax_rate || 16);

  const handleSubmit = (e) => {
    e.preventDefault();
    onUpdate({ tax_rate: taxRate });
  };

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Tax Settings</h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Default VAT Rate (%)
          </label>
          <input
            type="number"
            value={taxRate}
            onChange={(e) => setTaxRate(parseFloat(e.target.value))}
            className="input-field w-48"
            step="0.5"
            min="0"
            max="100"
          />
          <p className="text-xs text-gray-500 mt-1">Current KRA standard rate is 16%</p>
        </div>
        <button type="submit" disabled={loading} className="btn-primary">
          {loading ? 'Saving...' : 'Save Changes'}
        </button>
      </form>
    </div>
  );
}